/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import { loadFonts } from './webfontloader'
import { setupVuetify } from './vuetify'
import pinia from '../store'
import router from '../router'
import Vueform from '@vueform/vueform'
import vueformConfig from './vueform'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import i18n from '../i18n'
import { useSocietyStore } from '../store/society'

// Types
import type { App } from 'vue'

/** Lee un mensaje del diccionario activo sin pasarlo por la interpolación de vue-i18n. */
function rawMessage (path: string, fallback: string): string {
  const messages = i18n.global.getLocaleMessage(i18n.global.locale.value) as Record<string, unknown>
  const value = path.split('.').reduce<unknown>(
    (node, key) => (node as Record<string, unknown> | undefined)?.[key], messages,
  )
  return typeof value === 'string' ? value : fallback
}

export function registerPlugins (app: App) {
  loadFonts()
  
  // Initialize i18n first
  app.use(i18n)
  
  // Then initialize Vuetify with table translations
  const vuetify = setupVuetify(app, {
    itemsPerPageText: i18n.global.t('common.dataTable.itemsPerPageText') as string,
    noDataText: i18n.global.t('common.dataTable.noDataText') as string,
    // El default de Vuetify es "{0}-{1} of {2}" y quedó sin traducir cuando se tradujeron sus dos
    // hermanos, así que toda la app mostraba el "of" en inglés al pie de cada tabla.
    //
    // Se lee CRUDO del diccionario y no con t(): los {0}/{1}/{2} son placeholders de Vuetify, y
    // vue-i18n los interpreta como suyos, no recibe argumentos y los reemplaza por nada — el pie
    // queda diciendo "- de" en vez de "1-25 de 27".
    pageText: rawMessage('common.dataTable.pageText', '{0}-{1} of {2}')
  })
  app.use(vuetify)

  // Initialize Pinia before router (router guards use stores)
  app.use(pinia)
  
  // Initialize other plugins
  app
    .use(router)
    .use(Vueform, vueformConfig)
    .use(FloatingVue)
  
  // Inject societyStore as a global property (after pinia is registered)
  app.config.globalProperties.$societyStore = useSocietyStore()
}
